import { DialogTitle, Dialog, DialogContent, Button, DialogActions } from '@mui/material';
import { DateRange } from 'ui/DateRange';
import { FC, useEffect, useState } from 'react';
import { EAllowedDateDirection } from 'ui/DateRange/types';
import { useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';

interface IDateRangeModalProps {
	open: boolean;
	setClose: () => void;
	selector?: string;
}

export const DateRangeModal: FC<IDateRangeModalProps> = ({ open, setClose, selector = '' }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [startDate, setStartDate] = useState<Date | null>(null);
	const [endDate, setEndDate] = useState<Date | null>(null);

	useEffect(() => {
		if (!open) return;
		const startDateStr = searchParams.get(`${selector}StartDate`);
		const endDateStr = searchParams.get(`${selector}EndDate`);
		if (startDateStr) {
			setStartDate(DateTime.fromISO(startDateStr).toJSDate());
		} else {
			setStartDate(null);
		}
		if (endDateStr) {
			setEndDate(DateTime.fromISO(endDateStr).toJSDate());
		} else {
			setEndDate(null);
		}
	}, [open, searchParams, selector]);

	const handleSetStartDate = (date: Date | null) => {
		setStartDate(date);
	};

	const handleSetEndDate = (date: Date | null) => {
		setEndDate(date);
	};

	const handleApply = () => {
		setSearchParams((prevParams) => {
			const newSearchParams = new URLSearchParams(prevParams);
			if (startDate) {
				newSearchParams.set(`${selector}StartDate`, DateTime.fromJSDate(startDate).toISODate()!);
			} else {
				newSearchParams.delete(`${selector}StartDate`);
			}
			if (endDate) {
				newSearchParams.set(`${selector}EndDate`, DateTime.fromJSDate(endDate).toISODate()!);
			} else {
				newSearchParams.delete(`${selector}EndDate`);
			}
			return newSearchParams;
		});
		setClose();
	};

	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '700px',
					maxWidth: '700px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle style={{ fontSize: '18px', fontWeight: 'bold', color: '#006293' }}>
				Select Period
			</DialogTitle>
			<DialogContent>
				<DateRange
					startDate={startDate}
					endDate={endDate}
					setStartDate={handleSetStartDate}
					setEndDate={handleSetEndDate}
					allowedDateDirection={EAllowedDateDirection.PAST}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={handleApply}>Apply</Button>
			</DialogActions>
		</Dialog>
	);
};
